import {rpcCall} from "../../util/rpc/rpcCalls"
import {
    EditingUserDisabled,
    NoAccessToScopeError,
    NoEditHierarchyRightError,
    NoManageUsersRightError,
    NoRightsError,
    NoSubmitTTRightError,
    NoSuchUserError,
    NotAssignedError,
    NotFoundError
} from "../errors"

export default class CustomerInfoService {
    getAssignedUsers(customerId) {
        return rpcCall("CustomerInfoService.getAssignedUsers", [customerId], this._rpcErrorHandler);
    }

    updateAssignedUsers(customerId, addedUserIds, removeUserIds) {
        return rpcCall("CustomerInfoService.updateAssignedUsers", [customerId, addedUserIds, removeUserIds], this._rpcErrorHandler)
    }

    getManagers(customerId) {
        return rpcCall("CustomerInfoService.getManagers", [customerId], this._rpcErrorHandler)
    }

    updateManagers(customerId, addedUserIds, removeUserIds) {
        return rpcCall("CustomerInfoService.updateManagers", [customerId, addedUserIds, removeUserIds], this._rpcErrorHandler)
    }

    getAssignedUsersForAll() {
        return rpcCall("CustomerInfoService.getAssignedUsersForAll", [], this._rpcErrorHandler);
    }

    getManagersForAll() {
        return rpcCall("CustomerInfoService.getManagersForAll", [], this._rpcErrorHandler);
    }

    _rpcErrorHandler(rpcError) {
        rpcError.handleOnException('com.actimind.actitime.customer.NoSuchCustomerException', new NotFoundError());
        rpcError.handleOnException('com.actimind.actitime.services.NoRightsForRemoteCallException', new NoRightsError());
        rpcError.handleOnException('com.actimind.actitime.services.NoRightToEditHierarchyException', new NoEditHierarchyRightError());
        rpcError.handleOnException('com.actimind.actitime.services.NoRightsToManageAccountSettings', new NoManageUsersRightError());
        rpcError.handleOnException('com.actimind.actitime.services.UserIsNotAssignedToManagerException', new NotAssignedError())
        rpcError.handleOnException('com.actimind.actitime.services.NoRightsToSubmitTTException', new NoSubmitTTRightError())
        rpcError.handleOnException('com.actimind.actitime.services.UserHasNoAccessToScopeException', new NoAccessToScopeError())
        rpcError.handleOnException('com.actimind.actitime.administration.NoSuchUserException', new NoSuchUserError())
        rpcError.handleOnException('com.actimind.actitime.administration.UserIsDisabledException', new EditingUserDisabled())
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/rpc/CustomerInfoService.js